module.exports = __webpack_public_path__ + "img/FR30056.e6d36dc2.png";